import { render, staticRenderFns } from "./DashboSafi.vue?vue&type=template&id=9544a584"
import script from "./DashboSafi.js?vue&type=script&lang=js&external"
export * from "./DashboSafi.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports